import defaultState from "./state";

const errorSnackReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "ERROR_SNACK_CLOSE": {
      return Object.assign({}, state, {
        open: false,
      });
    }

    case "ERROR_SNACK_OPEN": {
      return Object.assign({}, state, {
        open: true,
        mensaje: action.mensaje,
        errorObject: action.errorObject,
      });
    }

    default:
      return state;
  }
};

export default errorSnackReducer;
